// eslint-disable-next-line
import Apis from '@/Apis/_'
import { CoreBase, ICoreBase } from './CoreBase'
import ResponseApi from '../interfaces/FactoryResponse'

class Agendamento extends CoreBase implements IAgendamento {
  async backofficeVoltaStatus(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeVoltaStatus(params)
    return response
  }

  async backofficeAgendamentoRealizaPreAgendamento(params: any): Promise<ResponseApi> {
    const { solicitacaoId } = params
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaPreAgendamento(solicitacaoId, params)
    return response
  }

  async backofficeAgendamentoRealizaRevisaoCirurgica(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaRevisaoCirurgica(params)
    return response
  }

  async backofficeAtualizarOrcamento(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAtualizarOrcamento(params)
    return response
  }
}

interface IAgendamento extends ICoreBase {
  backofficeVoltaStatus(params: any): Promise<ResponseApi>
  backofficeAgendamentoRealizaPreAgendamento(params: any): Promise<ResponseApi>
  backofficeAgendamentoRealizaRevisaoCirurgica(params: any): Promise<ResponseApi>
  backofficeAtualizarOrcamento(params: any): Promise<ResponseApi>
}

export {
  IAgendamento,
  Agendamento,
}
